import React from "react";
import ReactDOM from "react-dom";
import "./static/sass/index.scss";
import "./static/sass/reset.scss";
import "./static/sass/common.scss";
// import Base from './Base';
import Home from "./home";
import { ContextProvider } from "./context";

ReactDOM.render(
  <React.StrictMode>
    <ContextProvider>
      <Home />
    </ContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
